/**
 * Compatibility adapter that re-exports through composition-runtime-contract.
 */

export * from './composition-runtime-contract'
